import React, { createContext, useContext, useState, ReactNode } from "react"
import { useMe } from "~/api2/hooks/useMe"

interface CampContextValue {
  campId?: string
  setCampId: (campId: string) => void
}

const CampContext = createContext<CampContextValue>({
  campId: undefined,
  setCampId: () => {},
})

export const CampProvider = ({ children }: { children: ReactNode }) => {
  const [campId, setCampIdState] = useState<string | undefined>(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem("campId") || undefined
    }
    return undefined
  })

  const { data: user } = useMe()
  const userCampId = user?.camp_id

  const setCampId = (id: string) => {
    setCampIdState(id)
    if (typeof window !== "undefined") {
      localStorage.setItem("campId", id)
    }
  }

  return <CampContext.Provider value={{ campId: campId || userCampId, setCampId }}>{children}</CampContext.Provider>
}

export const useCampContext = () => useContext(CampContext)
